import Hades from '@adoratorio/hades';
import engine from './engine';
import { isTouchDevice } from './utils';

const hades = {
  ref: null,

  init(DOMElement, DOMContainer) {
    hades.ref = new Hades({
      mode: (/Edge/.test(navigator.userAgent) ? Hades.MODE.NATIVE : Hades.MODE.VIRTUAL),
      viewport: DOMElement,
      container: DOMContainer,
      easing: {
        duration: !isTouchDevice() ? 2000 : 200,
        mode: Hades.EASING.QUART,
      },
      aion: engine,
      scrollbar: null,
      touchMultiplier: 2,
    });
  },

  setBoundries(DOMElement, offset = 0) {
    hades.ref.boundries = Hades.createBoundries(
      0,
      0,
      0,
      (DOMElement.getBoundingClientRect().height - window.innerHeight) + offset,
    );
  },
};

export default hades;
